export const API_KEY = '8294000bd1b593b90e40496df1fee0d8aca98af6';
